// eslint-disable-next-line no-restricted-imports -- the main entry doesn't re-export the font URL builders
import { buildUbuntuUrl } from '@lmn/design-system/fonts/fontFaceDeclarations.js';

export const UBUNTU_PRELOAD_URLS = ['regular', '500', '700'].map((suffix) => buildUbuntuUrl('latin', suffix));

export const UBUNTU_FONT_STACK = "Ubuntu, 'Ubuntu Fallback', Arial, Helvetica, sans-serif";
